/* eslint-disable react-hooks/exhaustive-deps */
import { Badge, Button, Col, Form, Input, message, Row, Select } from 'antd'
import { createRef, useEffect, useState } from 'react';
import helper from '../../utils/helper';
import { errorMessage } from '../../utils/commonStringsConsts';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { invoiceCollections } from '../../stores/actions';
import { Segmented } from 'antd';
import { CloudUploadOutlined } from '@ant-design/icons'
import XLSX from "xlsx";
import { DataTable, Spinner } from '@operations/shared';
import { userCollectionColumns } from '../../utils/tableColumns'
import { CollectionAmountType, IInvoicesAmount } from '../../utils/commonInterfaces';
export default function AddCollectionData() {
    const dispatch = useDispatch();
    const { Option } = Select;
    const [form] = Form.useForm()
    const [companies, setCompanies] = useState([]);
    const [loadCompanies, setLoadCompanies] = useState(false);
    const [paymentCycles, setPaymentCycles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [collectionLoader, setCollectionLoader] = useState(false);
    const [users, setUsers] = useState([]);
    const collectionAmountOptions = [
        { key: '1', value: 'Manual Entry', label: 'Manual Entry' },
        { key: '2', value: 'Upload Excel Sheet', label: 'Upload Excel Sheet' }
    ];
    const [collectionAmountOption, setCollectionAmountOption] = useState<{ key: string; value: string; label: string }>(collectionAmountOptions[0]);
    const [validFiles, setValidFiles] = useState(false);
    const [uploadingErrorMessage, setUploadingErrorMessage] = useState('');
    const [uploadingError, setUploadingError] = useState(false);
    const [totalCollectedData, setTotalCollectedData] = useState([]);
    const [companyId, setCompanyId] = useState<number | null>(null);
    const [invoicesAmount, setInvoicesAmount] = useState<IInvoicesAmount | null>(null);
    const storeCompanies = async () => {
        try {
            setLoadCompanies(true);
            const allComp: any = await helper.getCompanies();
            if (allComp?.status === 200) {
                setLoadCompanies(false);
                setCompanies(allComp?.data?.data);
                return
            };
            setLoadCompanies(false);
            message.error(allComp?.message);

        } catch (er: any) {
            setLoadCompanies(false);
            message.error(`${errorMessage} with companies`);

        }

    }

    const getPaymentCycles = async (companyInfo: any) => {
        try {
            setLoading(true);
            const paymentCyclesRes: any = await helper.getPaymentCycles(companyInfo?.id)
            if (!paymentCyclesRes?.errorMessage) {
                setPaymentCycles(paymentCyclesRes)
            } else {
                message.error(paymentCyclesRes?.errorMessage)
            }
        }
        catch (error: any) {
            message.error(`${errorMessage} with payment cycles`);
        }
        setLoading(false)

    }

    const dropDownSearch = (input: string, option: { children: string; }) => {
        return option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
    }
    const resetAllFields = () => {
        form.resetFields()
        setInvoicesAmount(null)
        setUsers([])
        setUploadingError(false)
        setCollectionAmountOption(collectionAmountOptions[0])
        setTotalCollectedData([])
    }

    const selectedCompany = async (values: any, data: any) => {
        resetAllFields()
        form.setFieldsValue({ companyID: values })
        if (values) {
            setCompanyId(values);
            await getPaymentCycles(data?.data);
            return;
        }
    }
    useEffect(() => {
        resetAllFields()
        storeCompanies();
    }, [])

    const getInvoicesCollections = async (values: any) => {
        setCollectionLoader(true);
        const payloadData = {
            companyID: Number(values?.companyID),
            paymentCycle: Number(values?.paymentCycle),
            collectionAmount: Number(values?.totalCollectedAmount),
            splitType: Number(values?.splitType),
            users: values?.users
        }
        try {
            const res: any = await helper.submitCollections(payloadData);
            if (res?.data?.status === 200) {
                message.success(res?.data?.message)
                resetAllFields()
            } else {
                message.error(`${res?.data?.message}`);
                setCollectionLoader(false);
                return
            }
            const invoiceCollectionData = {
                ...values,
                ...res?.data
            }
            dispatch(invoiceCollections(invoiceCollectionData));
        } catch (error) {
            setCollectionLoader(false);
            message.error(`${errorMessage}`);
        }
        setCollectionLoader(false);

    }
    const getCollectionData = (values: any) => {
        let totalCollectionAmount = 0;
        const updatedValues = {
            ...values,
            users: users?.length > 0 ? users?.map((user: any) => {
                totalCollectionAmount += user?.amountPerUser;
                return {
                    userId: user?.userId,
                    amountPerUser: user?.amountPerUser
                }
            }) : null,
            splitType: collectionAmountOption?.key,
            totalCollectedAmount: values?.totalCollectedAmount ? values?.totalCollectedAmount : totalCollectionAmount,
        };
        getInvoicesCollections(updatedValues);
    }

    const fileInputRef: React.RefObject<HTMLInputElement> = createRef();
    const forwardClickToInputElement = () => {
        fileInputRef?.current!?.click();
    };
    const uploadSheetFile = () => {
        forwardClickToInputElement();
    }

    const showIncorrectFileFormatError = () => {
        setUploadingError(true);
        setUploadingErrorMessage('Incorrect File Format.');
        setUsers([]);
        setTotalCollectedData([]);
    }

    const handleFile = (file: any) => {
        setUploadingError(false)
        let file_size = file.size / (1024 * 1024), maxSize = 1, size;
        if (file.size < 1024) {
            size = file.size + ' B';
        } else if (file.size < (1024 * 1024)) {
            size = Math.floor(file.size / 1024) + ' KB';
        } else {
            size = Math.floor(file.size / (1024 * 1024)) + ' MB';
        }
        console.log(size);

        /* Boilerplate to set up FileReader */
        let acceptable_exe = helper.regexValidation.xlsxCsvRegex;
        if (!acceptable_exe.exec(file.name)) {
            setValidFiles(true);
        } else if (file_size > maxSize) {
            setValidFiles(true);
            // return Upload.LIST_IGNORE
        } else {
            setValidFiles(false);
            let fileReader = new FileReader(), rowObject: any, result, workbook: XLSX.WorkBook;

            fileReader.readAsBinaryString(file);
            fileReader.onload = (event: any) => {
                try {
                    result = event.target.result;
                    workbook = XLSX.read(result, { type: "binary", cellDates: true });

                    const firstSheetName = workbook.SheetNames[0];
                    if (!firstSheetName) {
                        showIncorrectFileFormatError();
                        return;
                    }

                    const firstSheet = workbook.Sheets[firstSheetName];
                    const headerRow = (XLSX.utils.sheet_to_json(firstSheet, { header: 1 })[0] || []) as string[];
                    const hasCorrectColumns = headerRow.includes('userId') && headerRow.includes('amountPerUser');

                    if (!hasCorrectColumns) {
                        showIncorrectFileFormatError();
                        return;
                    }

                    rowObject = helper.sheetToJson(firstSheet);

                    const validRows = (rowObject || []).filter((row: any) => {
                        const hasUserId = row.userId !== undefined && row.userId !== null && row.userId !== "";
                        const hasAmountPerUser = row.amountPerUser !== undefined && row.amountPerUser !== null && row.amountPerUser !== "" && row.amountPerUser !== 0;
                        return hasUserId && hasAmountPerUser;
                    });

                    if (validRows.length === 0) {
                        showIncorrectFileFormatError();
                        return;
                    }

                    setUsers(validRows);
                    setTotalCollectedData(validRows);
                    setUploadingError(false);
                    setUploadingErrorMessage('');
                } catch {
                    showIncorrectFileFormatError();
                }
            }
        }
    }
    const handleFileChange = (e: any) => {
        const files = e?.target?.files;
        if (files && files[0]) handleFile(files[0]);
        e.target.value = null;
    }

    const selectPaymentCycle = async (value: any) => {
        if (value && companyId) {
            try {
                setLoading(true);
                const invoiceAmount: any = await helper.getInvoiceAmount(companyId, value);
                setInvoicesAmount(invoiceAmount?.data?.data);
            }
            catch (error: any) {
                message.error(`${errorMessage} with invoice amount`);
            }
            setLoading(false)
        }
    }
    return (
        <>
            <div className='createEarlyPayment addCollection'>
                {loadCompanies ? <Spinner size={'large'} /> :
                    <div>
                        <Form name="nest-messages" onFinish={getCollectionData} form={form} >
                            <Row className='inputsRow'>
                                <Col span={24}>
                                    <label>Select a company <span>*</span></label>
                                    <Form.Item name={"companyID"} rules={[{ required: true, message: 'Required' }]}>
                                        <Select style={{ width: '100%' }}
                                            placeholder={'Select the company'}
                                            showSearch
                                            allowClear
                                            filterOption={((input, option: any) => dropDownSearch(input, option))}
                                            onChange={selectedCompany}
                                        >
                                            {Array.isArray(companies) && companies.map((company: any, key: number) => {
                                                return <Option value={company?.id} data={company} key={key}>{company?.name}</Option>
                                            })}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <label> Payment cycle <span>*</span></label>
                                    <Form.Item
                                        name="paymentCycle"
                                        rules={[{ required: true, message: 'Required' }]}
                                    >
                                        <Select placeholder="Select a payment cycle" disabled={loading} onChange={selectPaymentCycle}>
                                            {Array.isArray(paymentCycles) &&
                                                [...paymentCycles]?.reverse()?.map((paymentCycle: { id: number, paymentCycle: number, cutOffCycleDate: string, isLocked: boolean }) =>
                                                    <Option key={paymentCycle?.paymentCycle}>
                                                        {moment(paymentCycle?.cutOffCycleDate).format('Do MMM, YYYY')}
                                                        &nbsp; &nbsp; &nbsp;<Badge count={paymentCycle?.isLocked ? "Locked invoice" : 0} />
                                                    </Option>)}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <label> Total of unassigned collections </label>
                                    <Form.Item shouldUpdate={(prev, curr) => prev.paymentCycle !== curr.paymentCycle}>
                                        {({ getFieldValue }) => (
                                            <Input
                                                readOnly
                                                placeholder={'Total Unassigned Collection'}
                                                disabled={!getFieldValue('paymentCycle') || !invoicesAmount}
                                                value={form.getFieldValue('companyID') ? invoicesAmount?.totalRemainingUnassignedCollection : ''}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <label>Total Invoice Amount</label>
                                    <Form.Item shouldUpdate={(prev, curr) => prev.paymentCycle !== curr.paymentCycle}>
                                        {({ getFieldValue }) => (
                                            <Input
                                                readOnly
                                                placeholder={'Total invoice amount'}
                                                disabled={!getFieldValue('paymentCycle') || !invoicesAmount}
                                                value={form.getFieldValue('companyID') ? invoicesAmount?.totalInvoiceAmount : ''}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <label>Remaining Invoice Amount</label>
                                    <Form.Item shouldUpdate={(prev, curr) => prev.paymentCycle !== curr.paymentCycle}>
                                        {({ getFieldValue }) => (
                                            <Input
                                                readOnly
                                                placeholder={'Remaining Invoice Amount'}
                                                disabled={!getFieldValue('paymentCycle') || !invoicesAmount}
                                                value={form.getFieldValue('companyID') ? invoicesAmount?.totalRemainingInvoiceAmount : ''}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={24} style={{ marginTop: '1rem' }}>
                                    <Segmented
                                        className='w-full'
                                        options={collectionAmountOptions}
                                        value={form.getFieldValue('companyID') ? collectionAmountOption.value : collectionAmountOptions[0]?.value}
                                        onChange={(val) => {
                                            const selected = collectionAmountOptions.find(opt => opt.value === val);
                                            if (selected) setCollectionAmountOption(selected);
                                            if (selected?.key === CollectionAmountType.manual) {
                                                setUsers([])
                                                setTotalCollectedData([])
                                                setUploadingError(false);
                                            }
                                            else if (selected?.key === CollectionAmountType.uploadSheet) {
                                                form.setFieldsValue({ totalCollectedAmount: null })
                                            }
                                        }}
                                    />
                                </Col>
                                {(collectionAmountOption.key === CollectionAmountType.uploadSheet && form.getFieldValue('companyID')) && (<Col className='' span={24}
                                    style={{ display: 'flex', flexDirection: "column", justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }} onClick={uploadSheetFile}>
                                    <CloudUploadOutlined style={{ fontSize: '28px', margin: '22px 0 0px 0' }} />
                                    <label>
                                        Click to upload Excel file
                                    </label>
                                </Col>
                                )}
                                {(collectionAmountOption.key === CollectionAmountType.manual || !form.getFieldValue('companyID')) && (
                                    <Col span={12} style={{ marginTop: '1rem' }}>
                                        <label> Collection Amount <span>*</span></label>
                                        <Form.Item
                                            name="totalCollectedAmount"
                                            rules={[
                                                { required: true, message: 'Required' },
                                                {
                                                    pattern: /^\d*\.?\d+$/,
                                                    message: 'Please enter a valid number',
                                                },
                                                {
                                                    validator: (_, value) => {
                                                        if (/^0+(\.0+)?$/.test(String(value))) {
                                                            return Promise.reject('Collection Amount must be greater than zero');
                                                        }
                                                        return Promise.resolve();
                                                    }
                                                }
                                            ]}
                                        >
                                            <Input
                                                placeholder={'Enter Collection Amount'}
                                                type="number"
                                                min={1}
                                                step="any"
                                                inputMode="decimal"
                                            />
                                        </Form.Item>
                                    </Col>
                                )}
                                <Col span={24}>
                                    {collectionAmountOption.key === CollectionAmountType.uploadSheet && form.getFieldValue('companyID') && (
                                        <div>
                                            <div style={{ marginTop: 10 }}>
                                                <DataTable
                                                    columns={userCollectionColumns}
                                                    rows={totalCollectedData}
                                                    handleTableChange={() => { }}
                                                    pagination={false}
                                                    loading={false}
                                                    scrolling={{ x: 'max-content' }}
                                                />
                                                {validFiles && <p style={{ color: 'red', padding: '0.5rem 0' }}>{'Allowed extension CSV or XLS up to 1 MB'}</p>}
                                                {uploadingError && <p style={{ color: 'red', padding: '0.5rem 0' }}>{uploadingErrorMessage}</p>}
                                            </div>
                                            <form className="form-inline">
                                                <div className="form-group">
                                                    <label htmlFor="file">  </label>
                                                    <input
                                                        hidden
                                                        type="file"
                                                        className="form-control"
                                                        id="file"
                                                        ref={fileInputRef}
                                                        onChange={handleFileChange}
                                                        accept='.xlsx,.xls,.csv'
                                                    />
                                                </div>
                                            </form>
                                        </div>
                                    )}
                                </Col>
                                <Col span={24} style={{ display: 'flex', justifyContent: 'end' }}>
                                    <Form.Item>
                                        <Button className='btn' shape="round" type="primary" loading={collectionLoader} block htmlType="submit" style={{ paddingInline: '2rem' }} disabled={collectionLoader || uploadingError}>
                                            Submit
                                        </Button>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                }
            </div>
        </>
    )
}


